module.exports = __webpack_public_path__ + "static/media/pug.3e58f7f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/pug.png
// module id = 171
// module chunks = 0